/**
 * This helper is a workaround for the build CSS injection order bug.
 * See: https://github.com/mui-org/material-ui/issues/18919
 */
import { makeStyles } from '@material-ui/core'

type makeStylesType = typeof makeStyles
const makeStylesWrapper: makeStylesType = (style, options) => makeStyles(style, { index: 1, ...options })
export default makeStylesWrapper
